var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("basic_data")))
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("title"),
                error: _vm.$v.title.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.title.$touch },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                options: _vm.reward_campaigns.map(function(e) {
                  return { label: e.title, value: e.id }
                }),
                "float-label": _vm.$t("campaign"),
                error: _vm.$v.reward_campaign.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.reward_campaign.$touch },
              model: {
                value: _vm.reward_campaign,
                callback: function($$v) {
                  _vm.reward_campaign = $$v
                },
                expression: "reward_campaign"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("image")))
            ]),
            _c("uploader", {
              attrs: {
                content_type: "images",
                multiple: false,
                cropper: true,
                disable: _vm.showDisable
              },
              on: { fileUploaded: _vm.imageUploaded }
            }),
            _vm.image
              ? _c(
                  "p",
                  { staticClass: "q-mt-md file-url" },
                  [
                    _c("q-icon", {
                      attrs: { name: "fal fa-check", color: "positive" }
                    }),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.image_url_complete,
                          target: "_blank"
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$truncateLink(_vm.image)))]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("short_description"),
                error: _vm.$v.short_description.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.short_description.$touch },
              model: {
                value: _vm.short_description,
                callback: function($$v) {
                  _vm.short_description = $$v
                },
                expression: "short_description"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("q-select", {
              attrs: {
                options: _vm.timezones,
                "float-label": _vm.$t("timezone"),
                filter: "",
                error: _vm.$v.timezone.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.timezone.$touch },
              model: {
                value: _vm.timezone,
                callback: function($$v) {
                  _vm.timezone = $$v
                },
                expression: "timezone"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              attrs: {
                type: "datetime",
                "float-label": _vm.$t("start_date"),
                format: "DD/MM/YYYY HH:mm:ss",
                error: _vm.$v.start_date.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.start_date.$touch },
              model: {
                value: _vm.start_date,
                callback: function($$v) {
                  _vm.start_date = $$v
                },
                expression: "start_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              attrs: {
                type: "datetime",
                "float-label": _vm.$t("end_date"),
                format: "DD/MM/YYYY HH:mm:ss",
                error: _vm.$v.end_date.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.end_date.$touch },
              model: {
                value: _vm.end_date,
                callback: function($$v) {
                  _vm.end_date = $$v
                },
                expression: "end_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: {
                type: "number",
                "float-label": _vm.$t("score"),
                error: _vm.$v.checkin_score.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.checkin_score.$touch },
              model: {
                value: _vm.checkin_score,
                callback: function($$v) {
                  _vm.checkin_score = $$v
                },
                expression: "checkin_score"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("description")))
            ]),
            _c(
              "q-editor",
              {
                style: _vm.getErrorColorEditor(_vm.$v.description.$error),
                attrs: {
                  disable: _vm.showDisable,
                  error: _vm.$v.description.$error,
                  toolbar: [
                    ["bold", "italic", "strike", "underline"],
                    ["left", "center", "right", "justify"],
                    ["link", "upload"],
                    [
                      {
                        label: null,
                        icon: "fas fa-font",
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: [
                          "p",
                          "h1",
                          "h2",
                          "h3",
                          "h4",
                          "h5",
                          "h6",
                          "code"
                        ]
                      },
                      {
                        label: null,
                        icon: "fas fa-text-height",
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: [
                          "size-1",
                          "size-2",
                          "size-3",
                          "size-4",
                          "size-5",
                          "size-6",
                          "size-7"
                        ]
                      },
                      "removeFormat"
                    ],
                    ["quote", "unordered", "ordered"],
                    ["custom_btn"]
                  ],
                  definitions: {
                    bold: { label: null, icon: "fas fa-bold" },
                    italic: { label: null, icon: "fas fa-italic" },
                    strike: { label: null, icon: "fas fa-strikethrough" },
                    underline: { label: null, icon: "fas fa-underline" },
                    left: { label: null, icon: "fas fa-align-left" },
                    center: { label: null, icon: "fas fa-align-center" },
                    right: { label: null, icon: "fas fa-align-right" },
                    justify: { label: null, icon: "fas fa-align-justify" },
                    link: { label: null, icon: "fas fa-link" },
                    upload: {
                      tip: null,
                      icon: "fas fa-file-image",
                      handler: _vm.insertImg
                    },
                    removeFormat: { label: null, icon: "fas fa-eraser" },
                    quote: { label: null, icon: "fas fa-quote-right" },
                    unordered: { label: null, icon: "fas fa-list-ul" },
                    ordered: { label: null, icon: "fas fa-list-ol" }
                  }
                },
                on: { input: _vm.$v.description.$touch },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              },
              [
                _c("q-btn", {
                  attrs: {
                    slot: "custom_btn",
                    dense: "",
                    flat: "",
                    color: "black",
                    icon: "fal fa-code",
                    label: "HTML"
                  },
                  on: {
                    click: function($event) {
                      _vm.show_html = true
                    }
                  },
                  slot: "custom_btn"
                })
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("address")))
          ])
        ]),
        _vm.keyGooogleMaps
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.show_maps_alert,
                      "error-label": _vm.$t(
                        "not_found_check_that_the_search_is_spelled_correctly_and_try_to_add_a_street_address_and_the_number_of_valid_addresses"
                      )
                    }
                  },
                  [
                    _vm._v('"">\n                    '),
                    _c("q-autocomplete", {
                      attrs: { "min-characters": 3, separator: "" },
                      on: {
                        search: _vm.getAddressGoogleMaps,
                        selected: _vm.selectedAddressGoogleMaps
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-input",
                  {
                    attrs: {
                      "float-label": _vm.$t("address"),
                      error: _vm.$v.address.$error,
                      autocomplete: "new-password",
                      disable: _vm.showDisable
                    },
                    on: { input: _vm.$v.address.$touch },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  },
                  [
                    _c("q-autocomplete", {
                      attrs: { "min-characters": 3, separator: "" },
                      on: {
                        search: _vm.getAddress,
                        selected: _vm.selectedAddress
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              ref: "number",
              attrs: {
                "float-label": _vm.$t("number"),
                error: _vm.$v.number.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.number.$touch },
              model: {
                value: _vm.number,
                callback: function($$v) {
                  _vm.number = $$v
                },
                expression: "number"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("complement"),
                disable: _vm.showDisable
              },
              model: {
                value: _vm.complement,
                callback: function($$v) {
                  _vm.complement = $$v
                },
                expression: "complement"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("neighborhood"),
                disable: _vm.showDisable
              },
              model: {
                value: _vm.neighborhood,
                callback: function($$v) {
                  _vm.neighborhood = $$v
                },
                expression: "neighborhood"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("postal_code"),
                disable: _vm.showDisable
              },
              model: {
                value: _vm.postal_code,
                callback: function($$v) {
                  _vm.postal_code = $$v
                },
                expression: "postal_code"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("country"),
                error: _vm.$v.country.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.country.$touch },
              model: {
                value: _vm.country,
                callback: function($$v) {
                  _vm.country = $$v
                },
                expression: "country"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("state"),
                error: _vm.$v.state.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.state.$touch },
              model: {
                value: _vm.state,
                callback: function($$v) {
                  _vm.state = $$v
                },
                expression: "state"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("city"),
                error: _vm.$v.city.$error,
                disable: _vm.showDisable
              },
              on: { input: _vm.$v.city.$touch },
              model: {
                value: _vm.city,
                callback: function($$v) {
                  _vm.city = $$v
                },
                expression: "city"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                type: "number",
                "float-label": _vm.$t("latitude"),
                disable: _vm.showDisable
              },
              model: {
                value: _vm.lat,
                callback: function($$v) {
                  _vm.lat = $$v
                },
                expression: "lat"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: {
                type: "number",
                "float-label": _vm.$t("longitude"),
                disable: _vm.showDisable
              },
              model: {
                value: _vm.long,
                callback: function($$v) {
                  _vm.long = $$v
                },
                expression: "long"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4 flex  items-end justify-center" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                disabled: _vm.disabledButton,
                color: "primary",
                icon: "map",
                label: _vm.$t("see_on_map")
              },
              on: {
                click: function($event) {
                  return _vm.showMap()
                }
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 col-sm-12 q-mt-lg" }, [
          _c("span", { staticClass: "q-headline text-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("permission")))
          ])
        ])
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fal fa-clipboard-list-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        options: _vm.areas,
                        "float-label": _vm.$t("areas"),
                        error: _vm.$v.area.$error,
                        multiple: "",
                        chips: "",
                        disable: _vm.showDisable
                      },
                      on: { input: _vm.$v.area.$touch },
                      model: {
                        value: _vm.area,
                        callback: function($$v) {
                          _vm.area = $$v
                        },
                        expression: "area"
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: {
                              val: true,
                              label: _vm.$t("all"),
                              disable: _vm.showDisable
                            },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profile.$error)
                          },
                          [
                            _c("q-checkbox", {
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profile.$error),
                                disable: _vm.showDisable
                              },
                              on: { input: _vm.$v.profile.$touch },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-select", {
                            attrs: {
                              options: _vm.getReward_levels,
                              "float-label": _vm.$t("user_level"),
                              error: _vm.$v.reward_level.$error,
                              multiple: "",
                              chips: "",
                              disable: _vm.showDisable
                            },
                            on: { input: _vm.$v.reward_level.$touch },
                            model: {
                              value: _vm.reward_level,
                              callback: function($$v) {
                                _vm.reward_level = $$v
                              },
                              expression: "reward_level"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("status")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorStatus,
                options: _vm.statuses,
                disable: _vm.showDisable
              },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_html,
            callback: function($$v) {
              _vm.show_html = $$v
            },
            expression: "show_html"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_html = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v("\n                    HTML\n                ")
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          rows: "10",
                          "float-label": "HTML"
                        },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "far fa-ban"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_html = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "events" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }